import { render, staticRenderFns } from "./RegistraPezzi.vue?vue&type=template&id=5fd20be6&scoped=true&"
import script from "./RegistraPezzi.vue?vue&type=script&lang=js&"
export * from "./RegistraPezzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd20be6",
  null
  
)

export default component.exports